export default __webpack_public_path__ + "static/media/seller_customer.4f12cab5.xlsx";